/* gvb-proof-compare.js · "How it compares" (.vs) · sections/gvb-comparison.liquid (port of final-b2/_src/sp2/compare.js)
   One global: window.glevaCompareInit(root). Runs on DOMContentLoaded and on shopify:section:load; idempotent.
   - Toggle: role=tablist/tab on the base .seg; click, arrows, Home, End; roving tabindex; panels use [hidden].
     Fires a bubbling `vs:view` {view}. In the theme editor, selecting a block shows its view.
   - CTA [data-vs-add]: mirrors the buy box's Add to cart ([data-atc] with [data-atc-label] / [data-atc-price],
     disabled / .is-soldout) and, when pressed, presses it, so tiers, Kaching, the toast and the sticky bar stay in one
     place. Shows "Added to cart" for 1.6 s once the add lands (variant:add). Without a buy box on the page it adds
     its own variant through GVB.cartAdd (or /cart/add as a last resort); so does a CTA marked [data-vs-own] (the
     section shows another product than the page's).
   - CTA [data-vs-link]: same-page link (#tiers): scrolls the target to the centre and focuses it. */
(function () {
  'use strict';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function select(sec, i, focus) {
    var btns = $$('[data-vs-tabs] [role="tab"]', sec);
    if (!btns[i]) return;
    btns.forEach(function (b, j) {
      var on = i === j;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) btns[i].focus();
    sec.dispatchEvent(new CustomEvent('vs:view', { bubbles: true, detail: { view: btns[i].id } }));
  }

  function tabs(sec) {
    var btns = $$('[data-vs-tabs] [role="tab"]', sec);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(sec, i, false); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = btns.length, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = n - 1;
        if (j < 0) return;
        e.preventDefault(); select(sec, j, true);
      });
    });
  }

  function buyBox() {
    return document.querySelector('[data-gvb-pdp] [data-atc]') || document.querySelector('[data-atc]');
  }

  function flash(m) {
    m.classList.add('is-added');
    clearTimeout(m._vsT);
    m._vsT = setTimeout(function () { m.classList.remove('is-added'); }, 1600);
  }

  function cta(sec) {
    var all = $$('[data-vs-add]', sec);
    var mine = all.filter(function (m) { return !m.hasAttribute('data-vs-own'); });
    if (all.length) {
      var atc = mine.length ? buyBox() : null;
      var srcLabel = atc && atc.querySelector('[data-atc-label]');
      var srcPrice = atc && atc.querySelector('[data-atc-price]');
      var sync = function () {
        mine.forEach(function (m) {
          var lbl = m.querySelector('[data-vs-label]'), price = m.querySelector('[data-vs-price]');
          var lt = srcLabel && srcLabel.textContent.replace(/\s+/g, ' ').trim();
          var pt = srcPrice && srcPrice.textContent.replace(/\s+/g, ' ').trim();
          if (lt && lbl && lbl.textContent !== lt) lbl.textContent = lt;
          if (pt && price && price.textContent !== pt) price.textContent = pt;
          if (atc) {
            m.disabled = !!atc.disabled;
            m.classList.toggle('is-soldout', atc.classList.contains('is-soldout'));
          }
        });
      };
      sync();
      if (atc && window.MutationObserver) {
        var mo = new MutationObserver(sync);
        [srcLabel, srcPrice].forEach(function (n) { if (n) mo.observe(n, { characterData: true, childList: true, subtree: true }); });
        mo.observe(atc, { attributes: true, attributeFilter: ['class', 'disabled'] });
      }
      var pending = null;
      document.addEventListener('variant:add', function () {
        if (pending && Date.now() - pending.t < 8000) flash(pending.m);
        pending = null;
      });
      all.forEach(function (m) {
        m.addEventListener('click', function () {
          if (m.disabled) return;
          var box = m.hasAttribute('data-vs-own') ? null : buyBox();
          if (box) {
            if (box.disabled) return;
            pending = { m: m, t: Date.now() };
            box.click();
            return;
          }
          var id = Number(m.getAttribute('data-variant-id'));
          if (!id) return;
          if (window.GVB && window.GVB.cartAdd) {
            m.setAttribute('aria-busy', 'true');
            window.GVB.cartAdd([{ id: id, quantity: 1 }], {
              name: m.getAttribute('data-name') || '', price: Number(m.getAttribute('data-price')) || null,
              thumb: m.getAttribute('data-thumb') || '', source: m
            }).then(function () { flash(m); }).catch(function () {}).then(function () { m.removeAttribute('aria-busy'); });
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add?id=' + id + '&quantity=1';
          }
        });
      });
    }
    $$('[data-vs-link]', sec).forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var id = href.slice(1), t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        t.focus({ preventScroll: true });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  }

  window.glevaCompareInit = function (root) {
    var list = $$('[data-vs]', root || document);
    if (root && root.matches && root.matches('[data-vs]')) list.unshift(root);
    list.forEach(function (sec) {
      if (sec._vsInit) return;
      sec._vsInit = true;
      tabs(sec);
      cta(sec);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.glevaCompareInit(); });
  else window.glevaCompareInit();
  document.addEventListener('shopify:section:load', function (e) { window.glevaCompareInit(e.target); });
  /* theme editor: selecting a row or view block shows the view that holds it */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target, panel = t && t.closest && t.closest('[data-vs-panel]');
    if (!panel || !panel.hidden) return;
    var sec = panel.closest('[data-vs]');
    var btns = $$('[data-vs-tabs] [role="tab"]', sec);
    btns.forEach(function (b, i) { if (b.getAttribute('aria-controls') === panel.id) select(sec, i, false); });
  });
})();
